import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Inbox, FileText, Users, Newspaper } from 'lucide-react';
import api from '../../lib/api';

export default function Dashboard() {
  const [stats, setStats] = useState({ enquiries: 0, team: 0, articles: 0, contentKeys: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [enq, tm, arts, ctnt] = await Promise.all([
          api.get('/enquiries'), api.get('/team/admin'), api.get('/articles/admin'), api.get('/content')
        ]);
        setStats({ enquiries: enq.data.length, team: tm.data.length, articles: arts.data.length, contentKeys: Object.keys(ctnt.data).length });
      } catch (err) {
        console.error('Failed to load dashboard stats:', err);
      }
    })();
  }, []);

  const cards = [
    { label: 'Enquiries', v: stats.enquiries, to: '/admin/enquiries', icon: Inbox },
    { label: 'Content blocks', v: stats.contentKeys, to: '/admin/content', icon: FileText },
    { label: 'Team members', v: stats.team, to: '/admin/team', icon: Users },
    { label: 'Articles', v: stats.articles, to: '/admin/articles', icon: Newspaper },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-serif text-cream-50 text-4xl">Welcome back</h1>
        <p className="text-cream-100/60 mt-1">Overview of your content, team and enquiries.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(({ label, v, to, icon: Icon }) => (
          <Link key={label} to={to} className="bg-forest-900 border border-forest-800 hover:border-sage-500/50 transition-colors p-6">
            <Icon className="h-5 w-5 text-sage-400" />
            <p className="mt-4 text-4xl font-serif text-cream-50">{v}</p>
            <p className="mt-1 text-sm text-cream-100/60">{label}</p>
          </Link>
        ))}
      </div>
      <div className="bg-forest-900 border border-forest-800 p-6">
        <h2 className="font-serif text-cream-50 text-2xl">Quick tips</h2>
        <ul className="mt-4 space-y-2 text-cream-100/75 text-sm list-disc list-inside">
          <li>Edit site copy in <Link className="text-sage-400 hover:underline" to="/admin/content">Content</Link> - changes are live immediately.</li>
          <li>Reply to an enquiry by clicking the email address in <Link className="text-sage-400 hover:underline" to="/admin/enquiries">Enquiries</Link>.</li>
          <li>Rate limiting, input sanitisation and injection guards are active on all endpoints.</li>
        </ul>
      </div>
    </div>
  );
}
